import { useCallback } from "react";
import { useSelector, useDispatch } from "react-redux";
import * as actions from './actions'

export const useProfileGallery = () => {

    const {
        photos=[],
        initialize,
        loadMore,
        limit,
        total,
        isRequesting

    } = useSelector((state) => state.profileGallery);

    const dispatch = useDispatch();

    const refreshPhotos = useCallback(
        () => dispatch(actions.refreshPhotos()),
        [dispatch]
    );

    const setPhotos = useCallback(
        (payload) => dispatch(actions.setPhotos(payload)),
        [dispatch]
    );

    const addPhoto = useCallback(
        (payload) => dispatch(actions.addPhoto(payload)),
        [dispatch]
    );

    const updatePhoto = useCallback(
        (payload) => dispatch(actions.updatePhoto(payload)),
        [dispatch]
    );
    const finishGetPhoto = useCallback(
      (payload) => dispatch(actions.finishGetPhoto(payload)),
      [dispatch]
    );

     const getPhoto = useCallback(
        (payload) => dispatch(actions.getPhoto(payload)),
        [dispatch]
      );

      const deletePhoto = useCallback(
        (payload) => dispatch(actions.deletePhoto(payload)),
        [dispatch]
      )


    return {
        initialize,
        photos,
        setPhotos,
        addPhoto,
        updatePhoto,
        refreshPhotos,
        loadMore,
        limit,
        total,
        finishGetPhoto,
        getPhoto,
        isRequesting,
        deletePhoto
    };
} 